import React from 'react';
import { makeStyles} from '@material-ui/core/styles';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux'
import { Drawer, List } from '@material-ui/core';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import ExplicitIcon from '@material-ui/icons/Explicit';
import ViewCompactIcon from '@material-ui/icons/ViewCompact';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import AppsIcon from '@material-ui/icons/Apps';
import PropTypes from 'prop-types';
// import Logo from '../../Assets/Images/logo.png';
import Logo from '../../Assets/Images/newlogo.png';
import RSLogo from '../../Assets/Images/rslogo.png';
import Button from '@material-ui/core/Button';
import * as actions from '../../Store/Actions';
import useReactRouter from 'use-react-router';
import { authProvider } from '../../authProvider';

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
  },
  drawer: {
    [theme.breakpoints.up('sm')]: {
      width: drawerWidth,
      flexShrink: 0,
    },
  },
  appBar: {
    [theme.breakpoints.up('sm')]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      display: 'none',
    },
  },
  menuButton1: {
    marginRight: 0
  },
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    width: drawerWidth,
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
  },
  typ: {
    flexGrow: 1,
  },
  icon:{
    color:'black'
  },
  link:{
    textDecoration:'none',
    color:'inherit'
  }

}));
export default function Admin() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { history } = useReactRouter();

  const logoutHandler = () =>{
    dispatch(actions.authLogout())
    authProvider.logout();
    // history.push("/Login");
  }

  return (
    <div>
      <CssBaseline />
      <AppBar position="fixed" color='transparent' className={classes.appBar}>
        <Toolbar>
          <Typography variant="h6" noWrap justify="center" className={classes.typ}>
            Admin Portal
        </Typography>

          <Button style={{'borderRadius': '50px'}} variant="contained" color="primary" onClick={() => logoutHandler()}>
            Logout
          </Button>

        </Toolbar>
      </AppBar>

      <nav className={classes.drawer} aria-label="mailbox folders">
        <Drawer
          variant="permanent"
          open
          classes={{
            paper: classes.drawerPaper,
          }}>
          <div>
            <div className={classes.toolbar} >
            <a href="https://pact.riversand.com"><img src={RSLogo} alt="Riversand" style={{height:'38px',marginTop:'15px',marginLeft:'10px'}}></img></a>
            {/* <img src={Logo} alt="Dataio" style={{height:'45px',marginTop:'10px',marginLeft:'50px'}}></img> */}
            </div>
            <Divider />
            <List>
              {/* <Link to="/user" className={classes.link}>
                <ListItem button key="Users">
                  <ListItemIcon><PeopleAltIcon className={classes.icon} /></ListItemIcon>
                  <ListItemText primary="User" />
                </ListItem>
              </Link>
              <Link to="/environment" className={classes.link}>
                <ListItem button key="Environment">
                  <ListItemIcon><ExplicitIcon className={classes.icon} /></ListItemIcon>
                  <ListItemText primary="Environment" />
                </ListItem>
              </Link> */}
              <Link to="/Apps" className={classes.link}>
                <ListItem button key="Apps">
                  <ListItemIcon><AppsIcon className={classes.icon}/></ListItemIcon>
                  <ListItemText primary="Apps" />
                </ListItem>
              </Link>
              <Link to="/Components" className={classes.link}>
                <ListItem button key="Component">
                  <ListItemIcon><ViewCompactIcon className={classes.icon}/></ListItemIcon>
                  <ListItemText primary="Components" />
                </ListItem>
              </Link>
            </List>
            <Divider />
          </div >
        </Drawer>
      </nav>
    </div>
  );
}
Admin.propTypes = {
  container: PropTypes.instanceOf(typeof Element === 'undefined' ? Object : Element),
};
